import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description: 'Jira epics, the parents that group Jira tasks and stories.',
    name: 'Epics',
    partialId: PartialId.Standard.create('epics'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
